/**
 * Folding of dashboard widgets. Folds are saved on the user's profile, so they
 * follow the user from one computer to another. Every widget starts unfolded.
 *
 * In a widget: a `widget-fold-button` in the card header, `widget-folded` on the
 * card and `v-show="!isWidgetFolded(key)"` on what the fold hides.
 */
export default {
  computed: {
    foldedDashboardWidgets() {
      return this.$store.getters["profile/foldedDashboardWidgets"];
    },
  },

  methods: {
    isWidgetFolded(widget) {
      return this.foldedDashboardWidgets.includes(widget);
    },

    async toggleWidgetFold(widget) {
      try {
        await this.$store.dispatch("profile/foldDashboardWidget", {
          widget,
          folded: !this.isWidgetFolded(widget),
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
